import React from 'react';

export type BreadcrumbProps = {
  children?: React.ReactNode;
  Separator?: React.ReactNode;
  className?: string;
  listClassName?: string;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ children, Separator, className = '', listClassName }) => {
  return (
    <nav
      className={`max-w-full overflow-x-auto scrollbar-hide ${className}`}
      aria-label="Breadcrumb"
      data-testid="atom-breadcrumb"
    >
      <ol role="list" className={`items-center justify-start gap-x-4 gap-y-22 whitespace-pre px-16 ${listClassName}`}>
        {React.Children.map(children, (Child, index) => (
          <React.Fragment key={index}>
            <li className="py-13">
              <button type="button" data-testid={`atom-breadcrumb-item-${index}`}>
                {Child}
              </button>
            </li>
            {Separator && <li>{index < React.Children.count(children) - 1 && <span>{Separator}</span>}</li>}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
